import { Component } from "react";
import $ from "jquery";
import queryString from "query-string";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Segment, Button, Form } from "semantic-ui-react";

import { setFlashMessage } from "../actions/setFlashMessage";

import FormError from "./FormError";
import { TextInput, HeaderText } from "./Login";

class ResetPassword extends Component {
  state = {
    password: "",
    password_confirmation: "",
    loading: false,
    resetSuccess: false,
    showError: false,
    invalidResetUrl: false,
    initialLoad: true,
    error: "",
  };

  componentDidMount() {
    this.verifyResetToken();
  }

  verifyResetToken = () => {
    const { reset_password_token } = queryString.parse(
      this.props.location.search
    );

    if (!reset_password_token) {
      return this.setState({
        invalidResetUrl: true,
        initialLoad: false,
        error: "Oops! This isn't a valid password reset link.",
      });
    }

    return $.ajax({
      url: "/users/password/edit",
      type: "GET",
      dataType: "json",
      data: { reset_password_token },
    })
      .then(({ email, user_root_path, token_valid, pending_setup }) => {
        if (pending_setup) {
          this.props.setFlashMessage(
            "Please specify your password and other account details."
          );
          return this.props.history.push(
            `user_registration?reset_password_token=${reset_password_token}`
          );
        }

        if (token_valid) {
          this.setState({
            error: "",
            initialLoad: false,
            invalidResetUrl: false,
            email,
            user_root_path,
            reset_password_token,
          });
        } else {
          this.setState({
            error: "This password reset link has expired.",
            initialLoad: false,
            invalidResetUrl: true,
          });
        }
      })
      .catch(({ responseText }) => {
        const { error } = JSON.parse(responseText);

        this.setState({
          error,
          invalidResetUrl: true,
          initialLoad: false,
        });
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    return $.ajax({
      url: "/users/password",
      type: "PUT",
      dataType: "json",
      data: {
        user: {
          email: this.state.email,
          password: this.state.password,
          password_confirmation: this.state.password_confirmation,
          reset_password_token: this.state.reset_password_token,
        },
      },
    })
      .then(() => {
        this.setState({
          loading: false,
          resetSuccess: true,
          error: "",
        });

        window.location.href = this.state.user_root_path;
      })
      .catch(({ responseText }) => {
        const error = [];
        const {
          errors: { password, reset_password_token },
        } = JSON.parse(responseText);

        password &&
          password.map((err) =>
            err.match(/passwords/gi)
              ? error.push(err)
              : error.push(`Password ${err}`)
          );
        reset_password_token &&
          reset_password_token.map((err) =>
            error.push(`Reset password token ${err}`)
          );

        this.setState({
          loading: false,
          showError: true,
          error,
        });
      });
  };

  render() {
    const {
      loading,
      error,
      resetSuccess,
      password,
      password_confirmation,
      showError,
      invalidResetUrl,
    } = this.state;

    if (this.state.initialLoad) {
      return (
        <Segment className="login forgot-password">
          <p>Loading...</p>
        </Segment>
      );
    }

    if (invalidResetUrl) {
      return (
        <Segment className="login forgot-password">
          <HeaderText textAlign="center" as="h2">
            Reset your password
          </HeaderText>
          <p>
            {error}&nbsp;Please click the link below to reset your password
            again.
          </p>
          <p className="reset">
            <Link to="/forgot_password">Reset my password</Link>
          </p>
        </Segment>
      );
    }

    return (
      <Segment className="login forgot-password">
        {!resetSuccess ? (
          <HeaderText textAlign="center" as="h2">
            Reset your password
          </HeaderText>
        ) : (
          <HeaderText textAlign="center" as="h2">
            Success! <br />
            Your password has been reset.
          </HeaderText>
        )}

        <FormError error={error} />

        {!resetSuccess && (
          <p>Please create a new password for {this.state.email}</p>
        )}

        {!resetSuccess ? (
          <Form onSubmit={this.handleSubmit}>
            <Form.Input
              control={TextInput}
              value={password}
              onChange={(e, { value }) =>
                this.setState({ password: value, showError: false })
              }
              name="password"
              type="password"
              placeholder="New Password (at least 8 characters, 1 Uppercase, 1 Lowercase, 1 Number, 1 Special Character)"
              fluid
              autoFocus
              error={error.length > 0 && showError}
            />

            <Form.Input
              control={TextInput}
              value={password_confirmation}
              onChange={(e, { value }) =>
                this.setState({
                  password_confirmation: value,
                  showError: false,
                })
              }
              name="password_confirmation"
              placeholder="Confirm new password"
              type="password"
              fluid
              error={error.length > 0 && showError}
            />

            <Button
              loading={loading}
              type="submit"
              fluid
              className="primary"
              disabled={
                password.trim().length === 0 ||
                password_confirmation.trim().length === 0 ||
                loading
              }
            >
              Reset my password
            </Button>
          </Form>
        ) : (
          <p>Taking you to your dashboard...</p>
        )}
      </Segment>
    );
  }
}

export default withRouter(connect(null, { setFlashMessage })(ResetPassword));
